import React, { useEffect } from 'react';
import { MessageContainer } from './RotateMessage.style';
const RotateMessage = () => {

  return (
    <MessageContainer>
      <div className="phone"></div>
      <div className="message">Please use ipad or desktop devices</div>
    </MessageContainer>
  );
};

export default RotateMessage;
